import { Component, Input } from "@angular/core";

@Component({
    selector: "web-profile-shimmer",
    templateUrl: "./profile-shimmer.component.html",
    styleUrls: ["./profile-shimmer.component.scss"],
})
export class ProfileShimmerComponent {
    @Input() height = "10px";
    @Input() width = "100%";
}
